import { supabase } from './supabase';

export interface AiChatResponse {
  reply: string;
  session_id: string;
  lead_capture_requested: boolean;
}

export async function sendAiMessage(
  showcaseId: string,
  message: string,
  sessionId: string | null
): Promise<AiChatResponse> {
  const { data, error } = await supabase.functions.invoke('showcase-ai-assistant', {
    body: {
      showcase_id: showcaseId,
      message,
      session_id: sessionId,
    },
  });

  if (error) throw error;
  return data as AiChatResponse;
}

export async function submitLead(
  showcaseId: string,
  lead: { name?: string; email?: string; phone?: string; message?: string },
  source: 'contact_form' | 'ai_assistant' | 'request_viewing'
): Promise<void> {
  const { error } = await supabase.from('showcase_leads').insert({
    showcase_id: showcaseId,
    name: lead.name || null,
    email: lead.email || null,
    phone: lead.phone || null,
    message: lead.message || null,
    source,
  });

  if (error) throw error;
}
